import React, { useState } from "react";
import DialogScreenMask from "../../components/DialogScreenMask";
import IllustCardBig from "../../components/IllustCardBig";
import Illusts from "../../components/Illusts/Illusts";
import IllustUnion from "../../components/IllustUnion";
import ScrollLocker from "../../lib/illusts/ScrollLock";
import "./IllustsPage.scoped.scss";

function IllustsPageContent(props: {
  readonly open: () => void;
  readonly close: () => void;
}) {
  const [currentElement, setCurrentElement] = useState<JSX.Element | null>(
    null
  );

  return (
    <div>
      <IllustUnion
        onClickIllust={(path) => {
          props.open();
          setCurrentElement(
            <div className="illustUnionDialog">
              <img src={path} alt="集合イラスト"></img>
            </div>
          );
        }}
      ></IllustUnion>
      <div className="anzu_font">
        <Illusts
          onClickIllust={(info) => {
            props.open();
            setCurrentElement(<IllustCardBig {...info}></IllustCardBig>);
          }}
        ></Illusts>
        <DialogScreenMask
          close={() => {
            props.close();
            setCurrentElement(null);
          }}
          visible={currentElement != null}
        >
          {currentElement}
        </DialogScreenMask>
      </div>
    </div>
  );
}

interface Props {}

export default function IllustsPage(props: Props) {
  // イラストをクリックしたときにダイアログとして出すがそのときにスクロールしないようにするための仕掛け
  React.useEffect(() => {
    // ブラウザバック等で解除せずに移動したときにも解除する。
    return () => ScrollLocker.unlock();
  });

  return (
    <div className="App-header">
      <IllustsPageContent
        open={() => ScrollLocker.lock()}
        close={() => ScrollLocker.unlock()}
      ></IllustsPageContent>
    </div>
  );
}
